<template>
  <div class="tableWithPerPageSelection">
    <a ref="lienDownload"></a>
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ $t('listeOrdreTravailTech.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="is-pulled-right buttons boutonAction">
              <a class="button is-addOrEdit"
                 @click="checkPermissions(constantes.PERM_ORDRE_TRAVAIL.maj)
          ? $router.push({ name: 'm.logistique.ordre_travail-techAdd'}) : showPopUp()"
                 :class="{'button-access-no-permission' :
               !checkPermissions(constantes.PERM_ORDRE_TRAVAIL.maj) }">
                {{ $t('listeOrdreTravailTech.actions.add')}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline mgt-20px level">
      <div class="level-left">
        <div class="column is-narrow">
          <selecteur-action
            @handleAction="manageActions"
            :options='actions'
            :placeholder='$t("general.placeHolder.groupedAction")'
            :titleButton="'general.button.apply'"
            :elementsSelectionnes="getAllOTSelected().length > 0"
          ></selecteur-action>
        </div>
        <div class="column is-narrow">
          <form @submit.prevent="recherche()">
            <b-input :placeholder="$t('general.button.search')"
                     type="search"
                     icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
        </div>
        <div class="column is-narrow">
          <button class="button" @click="setShowFiltre">
            <b-icon icon="filter-variant" size="is-small" type="is-default"/>
            <span class="is-size-7">
              {{$t('general.button.filtre')}}
              <label
                class="has-text-weight-bold"
                :class="nombreCritere > 0 ? '' : 'is-invisible'">
                ({{ nombreCritere }})
              </label>
            </span>
          </button>
          <span
            class="info-circle-right is-pulled-right is-cursor-pointer"
            @click="reinitialiserFiltre()">
            <b-icon icon="close-circle" type="is-danger"/>
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.PERM_ORDRE_TRAVAIL.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected"/>
      </div>
      <div slot="typeOt" slot-scope="props" >
        {{ getLibelleTypeIntervention(props.row.typeOtId )}}
      </div>
      <div slot="etat" slot-scope="props" >
        {{ getLibelleEtat(props.row.etat )}}
      </div>
      <div slot="dateSouhaitee" slot-scope="props" >
        {{ props.row.dateSouhaitee | formatDate }}
      </div>
      <div slot="datePlanification" slot-scope="props" >
        {{ props.row.datePlanification | formatDate }}
      </div>
      <div slot="dateFacture" slot-scope="props" >
        {{ props.row.dateFacture | formatDate }}
      </div>
      <div slot="dateRealisation" slot-scope="props" >
        {{ props.row.dateRealisation | formatDate }}
      </div>
      <div slot="technicien" slot-scope="props">
        {{ props.row.fournisseur ? props.row.fournisseur.nomCommercial : null }}
      </div>
      <div slot="montantHt" slot-scope="props" class="has-text-right">
        {{ props.row.montantHt | formatDevise }}
      </div>
      <div slot="patrimoine" slot-scope="props" v-if="props.row.otPatrimoine">
        <router-link-blank :to="getRouterLinkPatrimoine(props.row.otPatrimoine)"
                           :message="getLibellePatrimoine(props.row.otPatrimoine)"
                           typeIcon="is-primary" sizeIcon="is-small">
        </router-link-blank>
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.agenceId)}}
      </div>
      <div slot="dossier" slot-scope="props">
        <router-link-blank v-if="props.row.dossierLogistiqueTechniqueId"
                           :to="{ name: 'm.logistique.projets', params: {
                  id: props.row.dossierLogistiqueTechnique.projet.id }}"
                           class="lien"
                           :message="props.row.dossierLogistiqueTechnique
                ? props.row.dossierLogistiqueTechnique.libelle : null">
        </router-link-blank>
      </div>
      <div slot="projet" slot-scope="props">
        <router-link-blank v-if="props.row.dossierLogistiqueTechniqueId"
          :to="{ name: 'm.logistique.projets', params: {
                  id: props.row.dossierLogistiqueTechnique.projet.id }}"
          class="lien"
          :message="props.row.dossierLogistiqueTechnique
                ? props.row.dossierLogistiqueTechnique.projet.libelle : null">
        </router-link-blank>
      </div>
      <div slot="progression" slot-scope="props" class="has-text-right">
        <b-tooltip position="is-left" multilined type="is-primary">
          {{ props.row.taches.filter((t) => { return t.realise; }).length }} /
          {{ props.row.taches.length }}
          <template v-slot:content>
            <div v-for="(tache, index) in props.row.taches" :key="index">
              {{ tache.libelle }}
              <b-icon v-if="tache.realise"
                      type="is-white"
                      size="is-small"
                      icon="check-circle">
              </b-icon>
            </div>
          </template>
        </b-tooltip>
      </div>
      <div slot="adresse" slot-scope="props" v-if="props.row.otPatrimoine">
        {{ props.row.otPatrimoine.adresse | adresse }}
      </div>
      <div slot="ville" slot-scope="props" v-if="props.row.otPatrimoine">
        {{ props.row.otPatrimoine.adresse.ville }}
      </div>
      <div slot="codePostal" slot-scope="props" v-if="props.row.otPatrimoine">
        {{ props.row.otPatrimoine.adresse.codePostal }}
      </div>
      <div slot="code" slot-scope="props">
        <router-link
          :to="{ name: 'c.logistique.ordre_travail-tech', params: { id: props.row.id } }"
          class="lien"
          :class="{'text-access-no-permission':
          !checkPermissions(constantes.PERM_ORDRE_TRAVAIL.lecture)}">
          {{props.row.code}}
        </router-link>
      </div>
      <div slot="exporter" slot-scope="props">
        <a @click="checkPermissions(constantes.PERM_ORDRE_TRAVAIL.editer) ?
          edition(constantes.TYPE_PDF, props.row.id) : showPopUp()">
          <b-icon
            icon="file-pdf-box"
            type="is-primary"
            :class="{'text-access-no-permission' :
            !checkPermissions(constantes.PERM_ORDRE_TRAVAIL.editer)}">
          </b-icon>
        </a>
      </div>
      <div slot="edit" slot-scope="props">
        <router-link
          :to="{ name: 'm.logistique.ordre_travail-techEdition', params: { id: props.row.id} }">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(constantes.PERM_ORDRE_TRAVAIL.maj) }"></b-icon>
        </router-link>
      </div>
      <div slot="archive" slot-scope="" class="has-text-centered">
        <a @click="checkPermissions(constantes.PERM_ORDRE_TRAVAIL.supprimer) ?
          inProgress() : showPopUp()">
          <b-icon icon="archive" type="is-default"
                  :class="{
            'text-access-no-permission' : !checkPermissions(constantes.PERM_ORDRE_TRAVAIL.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
      <div slot="delete" slot-scope="props">
        <div @click="checkPermissions(constantes.PERM_ORDRE_TRAVAIL.supprimer)
        ? openPopUpDelete(props.row) : showPopUp()"
             class="is-cursor-pointer">
          <b-icon type="is-danger" icon="delete-forever" :class="{ 'text-access-no-permission' :
                      !checkPermissions(constantes.PERM_ORDRE_TRAVAIL.supprimer) }"
          ></b-icon>
        </div>
      </div>
    </v-server-table>
    <div class="componentBrief" v-show="showFiltre">
      <filtre-liste-ordre-travail-technique
        ref="filtreListeOrdreTravailTechnique"
        @toggleFiltre="setShowFiltre"
        @recherche="makeRechercheFilter"/>
    </div>
    <b-modal v-model="isComponentChangerEtatOtTechnique"
               has-modal-card
               class="modal">
      <pop-up-prevention
                :mess-header="messageHeader"
                :messagesPopup="messagesErreurPopUp"
                :isErrorPopup.sync="errorPopUp"
                :validate="$t('general.oui')"
                :cancel="$t('general.non')"
                @validateQuestions="updateEtatOtMultipe"
                :questions="questionsPopUpPrevention"
                @no="isComponentChangerEtatOtTechnique = false">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('listeOrdreTravailTech.popUpSuppression.title')"
        :isErrorPopup.sync="errorPopUp"
        :messagesPopup="messagesErreurPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :questions="questionsPopUpPrevention"
        @no="popUpSuppression = false"
        @validateQuestions="deleteOt"/>
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="{}"
        :choiceEdition=[]
        @editionChoose="editionOrdreTravail">
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import { ORDRE_TRAVAIL as PERM_ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import inProgress from '@/services/general/inProgress';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import selecteurAction from '@/components/general/selecteurAction';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import {
  ACTION_MASS_EDITION,
  ACTION_MASS_REALISATION,
  ACTION_MASS_ANNULATION,
  ACTION_MASS_EN_ATTENTE,
  ACTION_MASS_EN_COURS,
  ACTION_MASS_PLANIFIE,
  ACTION_MASS_CLOTURER,
  ACTION_MASS_A_EXPEDIER,
  ACTION_MASS_EXPEDIER,
} from '@/configuration/general/actionsConf';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import formatDate from '@/services/general/formatIsoDate';
import {
  TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE,
  ETAT_ANNULE,
  EXPORT_EXCEL_ORDRE_TRAVAIL,
  ETAT_EN_COURS,
  ETAT_REALISE,
  ETAT_EN_ATTENTE,
  ETAT_PLANIFIE,
  ETAT_CLOTURER,
  LIST_ETAT_OT_TECH,
  ETAT_A_EXPEDIER,
  ETAT_EXPEDIE,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import popUpEdition from '@/components/factures/p_edition';
import TableItemsInView from '@/components/general/TableItemsInView';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import filtreListeOrdreTravailTechnique
  from '@/components/logistique/ordreTravail/tech/liste/filtreListeOrdreTravailTechnique';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import transformer from '@/services/logistique/ordreTravail/tech/dataTransformer';
import genererCritereRecherche
  from '@/services/logistique/ordreTravail/tech/genererObject/genererCritereRecherche';
import changerEtatOtTechnique from '@/services/logistique/ordreTravail/tech/changerEtatOtTechnique';
import popUpPrevention from '@/components/general/popUpPrevention';
import { deleteOt } from '@/api/logistique/ordreTravailTech';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import validation from '@/services/logistique/ordreTravail/tech/validation/validation';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { columnsSplice } from '@/services/general/columns';
import edition from '@/api/edition/index';
import {
  MONTAGE,
  DEMONTAGE,
} from '@/configuration/logistique/typeOt/typeOtConfig';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_ORDRE_TRAVAIL_TECH } from '@/configuration/general/referenceTableConf';

const Permissions = createNamespacedHelpers('permissions');
const OT = createNamespacedHelpers('ordreTravailTech');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      actions: [
        { action: ACTION_MASS_ANNULATION, translation: 'listeOrdreTravailTech.actions.annuler' },
        { action: ACTION_MASS_CLOTURER, translation: 'listeOrdreTravailTech.actions.cloturer' },
        { action: ACTION_MASS_EN_ATTENTE, translation: 'listeOrdreTravailTech.actions.enAttente' },
        { action: ACTION_MASS_EN_COURS, translation: 'listeOrdreTravailTech.actions.enCours' },
        { action: ACTION_MASS_EDITION, translation: 'listeOrdreTravailTech.actions.editionMasse' },
        { action: ACTION_MASS_PLANIFIE, translation: 'listeOrdreTravailTech.actions.planifie' },
        { action: ACTION_MASS_REALISATION, translation: 'listeOrdreTravailTech.actions.realise' }],
      unsubscribeValue: null,
      showFiltre: false,
      popUpEdition: false,
      constantes: {
        PERM_ORDRE_TRAVAIL,
        TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE,
        EXPORT_EXCEL_ORDRE_TRAVAIL,
        TYPE_PDF,
      },
      isComponentChangerEtatOtTechnique: false,
      otTechnique: [],
      messageHeader: '',
      etatAchanger: null,
      idOtDelete: null,
      popUpSuppression: false,
      messagesErreurPopUp: [],
      errorPopUp: false,
      questionsPopUpPrevention: [],
      startArrayRendering: false,
      mountedLoadingEnd: false,
      referenceTable: REFERENCE_TABLE_ORDRE_TRAVAIL_TECH,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  components: {
    breadcrumb,
    selecteurAction,
    TableItemsInView,
    filtreListeOrdreTravailTechnique,
    routerLinkBlank,
    popUpPrevention,
    popUpEdition,
    parametrageTable,
    exportExcelButton,
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse, true);
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...OT.mapGetters({
      ordresTravail: 'items',
      totalCount: 'total',
      critereRecherche: 'critereRecherche',
      lastPayload: 'lastPayload',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeOrdreTravailTech.breadcrumb.ordresTravails'), route: '', isActive: true },
      ];
    },
    nombreCritere() {
      const banCritere = ['dates', 'datesPremierAffichage', 'datesValidite', 'auto', 'showOtSansDate', 'datesFacture', 'sansAudit', 'facture'];
      let nbCritere = calculNombreCritere(this.critereRecherche, banCritere);
      if (this.critereRecherche.datesPremierAffichage) {
        nbCritere += this.critereRecherche.datesPremierAffichage.dateDebut ? 1 : 0;
        nbCritere += this.critereRecherche.datesPremierAffichage.dateFin ? 1 : 0;
      }
      if (this.critereRecherche.dates) {
        nbCritere += this.critereRecherche.dates.dateDebut ? 1 : 0;
        nbCritere += this.critereRecherche.dates.dateFin ? 1 : 0;
      }
      if (this.critereRecherche.datesFacture) {
        nbCritere += this.critereRecherche.datesFacture.dateDebut ? 1 : 0;
        nbCritere += this.critereRecherche.datesFacture.dateFin ? 1 : 0;
      }
      if (this.critereRecherche.datesValidite) {
        nbCritere += this.critereRecherche.datesValidite.dateDebut ? 1 : 0;
        nbCritere += this.critereRecherche.datesValidite.dateFin ? 1 : 0;
      }
      nbCritere += this.critereRecherche.facture !== null ? 1 : 0;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$t('listeOrdreTravailTech.tabs.code'),
          etat: this.$t('listeOrdreTravailTech.tabs.etat'),
          typeOt: this.$t('listeOrdreTravailTech.tabs.type'),
          dateSouhaitee: this.$t('listeOrdreTravailTech.tabs.dateSouhaite'),
          datePlanification: this.$t('listeOrdreTravailTech.tabs.datePlanification'),
          dateFacture: this.$t('listeOrdreTravailTech.tabs.dateFacture'),
          dateRealisation: this.$t('listeOrdreTravailTech.tabs.dateRealisation'),
          technicien: this.$t('listeOrdreTravailTech.tabs.technicien'),
          montantHt: this.$t('listeOrdreTravailTech.tabs.montantHt'),
          patrimoine: this.$t('listeOrdreTravailTech.tabs.patrimoine'),
          progression: this.$t('listeOrdreTravailTech.tabs.progression'),
          agence: this.$t('listeOrdreTravailTech.tabs.agence'),
          dossier: this.$t('listeOrdreTravailTech.tabs.dossier'),
          projet: this.$t('listeOrdreTravailTech.tabs.projet'),
          codePostal: this.$t('listeOrdreTravailTech.tabs.codePostal'),
          adresse: this.$t('listeOrdreTravailTech.tabs.adresse'),
          ville: this.$t('listeOrdreTravailTech.tabs.ville'),
          codeFacture: this.$t('listeOrdreTravailTech.tabs.codeFacture'),
          exporter: '',
          edit: '',
          archive: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.critereRecherche);
          data.query.societeId = this.societeActiveId;
          if (data.query.datesPremierAffichage) {
            data.query.datesPremierAffichage.dateDebut = formatDate(
              data.query.datesPremierAffichage.dateDebut,
            );
            data.query.datesPremierAffichage.dateFin = formatDate(
              data.query.datesPremierAffichage.dateFin,
            );
          }
          if (data.query.dates) {
            data.query.dates.dateDebut = formatDate(data.query.dates.dateDebut);
            data.query.dates.dateFin = formatDate(data.query.dates.dateFin);
          }
          if (data.query.datesValidite) {
            data.query.datesValidite.dateDebut = formatDate(data.query.datesValidite.dateDebut);
            data.query.datesValidite.dateFin = formatDate(data.query.datesValidite.dateFin);
          }
          if (data.query.datesFacture) {
            data.query.datesFacture.dateDebut = formatDate(data.query.datesFacture.dateDebut);
            data.query.datesFacture.dateFin = formatDate(data.query.datesFacture.dateFin);
          }
          if (data.query.tiers.length > 0) {
            data.query.tiersId = data.query.tiers.map((client) => { return client.id; });
          }
          if (data.query.dossiers.length > 0) {
            data.query.dossiersId = data.query.dossiers.map((dossier) => { return dossier.id; });
          }
          if (data.query.projets.length > 0) {
            data.query.projetsId = data.query.projets.map((projet) => { return projet.id; });
          }
          delete data.query.tiers;
          delete data.query.projets;
          delete data.query.dossiers;
          if (!data.query.agencesId || data.query.agencesId.length === 0) {
            data.query.agencesId = this.agencesSelectionnees.map(agence => agence.agenceId);
          }
          if (data.query.otEtat.length === 0) {
            data.query.otEtat = LIST_ETAT_OT_TECH
              .filter(e => e.code !== ETAT_CLOTURER)
              .map(e => e.code);
          }
          return this.loadOrdreTravail(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.ordresTravail,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          exporter: 'colonneSelected',
          edit: 'colonneSelected',
          delete: 'colonneSelected',
          selected: 'colonneSelected',
          archive: 'colonneSelected',
        },
        sortable: ['code', 'typeOt', 'etat', 'dateSouhaitee', 'datePlanification', 'dateRealisation', 'dateFacture', 'montantHt', 'codeFacture'],
      };
    },
    iconSelectTotal() {
      if (this.allOTSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    columns() {
      const columns = ['selected', 'code', 'typeOt', 'etat', 'dateSouhaitee', 'datePlanification', 'dateRealisation', 'dateFacture', 'technicien', 'codeFacture', 'montantHt', 'adresse', 'codePostal', 'ville', 'patrimoine', 'dossier', 'projet', 'progression', 'agence', 'exporter', 'edit', 'archive', 'delete'];
      if (this.agencesSelectionnees.length === 1) {
        columnsSplice(columns, 'agence');
      }
      if (!this.afficherProjetDossier) {
        columnsSplice(columns, 'dossier');
        columnsSplice(columns, 'projet');
      }
      return columns;
    },
    allOTSelected() {
      return this.getAllOTSelected().length === this.ordresTravail.length
        && this.ordresTravail.length > 0;
    },
    afficherProjetDossier() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherProjetDossierLogistiqueTechnique
        .key);
    },
    moduleImpressionActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_ORDRE_TRAVAIL,
        typeExport: null,
        filtres: {
          query: transformer(this.lastPayload),
        },
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...OT.mapActions({
      loadOrdreTravail: 'loadOrdreTravail',
      setCritereRecherche: 'setCritereRecherche',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    getLibellePatrimoine(otPatrimoine) {
      if (otPatrimoine.faceId) return otPatrimoine.face.code;
      if (otPatrimoine.materielId) return otPatrimoine.materiel.code;
      if (otPatrimoine.dispositifId) return otPatrimoine.dispositif.code;
      if (otPatrimoine.emplacementId) return otPatrimoine.emplacement.code;
      return null;
    },
    getRouterLinkPatrimoine(otPatrimoine) {
      if (otPatrimoine.faceId) {
        return {
          name: 'c.gabed.emplacement-face',
          params: {
            id: otPatrimoine.face.materiel.dispositif.emplacement.id,
            idFace: otPatrimoine.faceId,
          },
        };
      }
      if (otPatrimoine.materielId) {
        return {
          name: 'c.gabed.emplacement-detailMateriel',
          params: {
            id: otPatrimoine.materiel.dispositif.emplacement.id,
            idMateriel: otPatrimoine.materielId,
          },
        };
      }
      if (otPatrimoine.dispositifId) {
        return {
          name: 'c.gabed.emplacement-detailDispositif',
          params: {
            id: otPatrimoine.dispositif.emplacement.id,
            idDispositif: otPatrimoine.dispositifId,
          },
        };
      }
      if (otPatrimoine.emplacementId) {
        return {
          name: 'c.gabed.emplacement-detailEmplacement',
          params: {
            id: otPatrimoine.emplacementId,
          },
        };
      }
      return null;
    },
    async edition(format, id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesErreurPopUp = [];
        const ids = id ? [id] : this.getAllOTSelected().map((ot => ot.id));
        const response = await edition({
          ids: ids,
          extension: format,
          typeDonnee: this.constantes.TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async editionOrdreTravail(format) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: this.getAllOTSelected().map(ot => ot.id),
          extension: format,
          typeDonnee: TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.popUpEdition = false;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeOrdreTravailTechnique.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeOrdreTravailTechnique.initializeFiltre();
      this.$refs.filtreListeOrdreTravailTechnique.viderCritere();
      this.$refs.filtreListeOrdreTravailTechnique.appliquerCritere();
      this.showFiltre = false;
    },
    manageActions(action) {
      this.messagesErreurPopUp = [];
      this.questionsPopUpPrevention = [];
      this.errorPopUp = false;
      if (action === ACTION_MASS_EDITION) {
        if (this.checkPermissions(PERM_ORDRE_TRAVAIL.editer)) {
          this.popUpEdition = true;
        } else this.showPopUp();
      }
      if (action === ACTION_MASS_ANNULATION) {
        if (this.checkPermissions(PERM_ORDRE_TRAVAIL.maj)) {
          const afficherSwitch = this.getAllOTSelected().map(ot => ot.typeOt)
            .some(el => el.actionInterventionOt === MONTAGE
             || el.actionInterventionOt === DEMONTAGE);
          const isImpactEtatDemandes = this.getAllOTSelected().filter(ot => {
            return ot.demandesLogistique.length > 0;
          }).length > 0;
          if (afficherSwitch) {
            this.questionsPopUpPrevention.push({
              key: 'isAnnulatonSuppression',
              value: true,
              message: 'listeOrdreTravailTech.popUpSuppression.aMonterADemonter',
            });
          }
          if (isImpactEtatDemandes) {
            this.questionsPopUpPrevention.push({
              key: 'impactEtatDemandes',
              message: this.$t('listeOrdreTravailTech.actionAnnulationImpactEtatDemande'),
              value: true,
            });
          }
          this.libelleCheckbox = '';
          this.isComponentChangerEtatOtTechnique = true;
          this.etatAchanger = ETAT_ANNULE;
          this.messageHeader = this.$t('listeOrdreTravailTech.annulerOt');
        } else this.showPopUp();
      }
      if (action === ACTION_MASS_PLANIFIE) {
        if (this.checkPermissions(PERM_ORDRE_TRAVAIL.maj)) {
          this.isComponentChangerEtatOtTechnique = true;
          this.etatAchanger = ETAT_PLANIFIE;
          this.messageHeader = this.$t('listeOrdreTravailTech.planifierOt');
        } else this.showPopUp();
      }
      if (action === ACTION_MASS_EN_ATTENTE) {
        if (this.checkPermissions(PERM_ORDRE_TRAVAIL.maj)) {
          this.isComponentChangerEtatOtTechnique = true;
          this.etatAchanger = ETAT_EN_ATTENTE;
          this.messageHeader = this.$t('listeOrdreTravailTech.enAttenteOt');
        } else this.showPopUp();
      }
      if (action === ACTION_MASS_EN_COURS) {
        if (this.checkPermissions(PERM_ORDRE_TRAVAIL.maj)) {
          this.isComponentChangerEtatOtTechnique = true;
          this.etatAchanger = ETAT_EN_COURS;
          this.messageHeader = this.$t('listeOrdreTravailTech.enCoursOt');
        } else this.showPopUp();
      }
      if (action === ACTION_MASS_CLOTURER) {
        if (this.checkPermissions(PERM_ORDRE_TRAVAIL.maj)) {
          this.isComponentChangerEtatOtTechnique = true;
          this.etatAchanger = ETAT_CLOTURER;
          this.messageHeader = this.$t('listeOrdreTravailTech.cloturerOt');
        } else this.showPopUp();
      }
      if (action === ACTION_MASS_A_EXPEDIER) {
        if (this.checkPermissions(PERM_ORDRE_TRAVAIL.maj)) {
          this.isComponentChangerEtatOtTechnique = true;
          this.etatAchanger = ETAT_A_EXPEDIER;
          this.messageHeader = this.$t('listeOrdreTravailTech.aExpedierOt');
        } else this.showPopUp();
      }
      if (action === ACTION_MASS_EXPEDIER) {
        if (this.checkPermissions(PERM_ORDRE_TRAVAIL.maj)) {
          this.isComponentChangerEtatOtTechnique = true;
          this.etatAchanger = ETAT_EXPEDIE;
          this.messageHeader = this.$t('listeOrdreTravailTech.expedierOt');
        } else this.showPopUp();
      }
      if (action === ACTION_MASS_REALISATION) {
        if (this.checkPermissions(PERM_ORDRE_TRAVAIL.maj)) {
          this.questionsPopUpPrevention.push({
            key: 'realiserActionIntervention',
            message: this.$t('listeOrdreTravailTech.actionIntervationTypeOt'),
            value: true,
          });
          this.questionsPopUpPrevention.push({
            key: 'impactEtatDemandes',
            message: this.$t('listeOrdreTravailTech.actionImpactEtatDemande'),
            value: true,
          });
          this.isComponentChangerEtatOtTechnique = true;
          this.etatAchanger = ETAT_REALISE;
          this.messageHeader = this.$t('listeOrdreTravailTech.realiserOt');
        } else this.showPopUp();
      }
    },
    getAllOTSelected() {
      return this.ordresTravail.filter((el) => { return el.selected; });
    },
    selectAll() {
      const select = !this.allOTSelected;
      this.ordresTravail.forEach(item => { item.selected = select; });
    },
    async makeRechercheFilter() {
      if (this.showFiltre) await this.setShowFiltre();
      this.recherche();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPage() {
      this.setCritereRecherche(genererCritereRecherche());
      this.$refs[this.referenceTable].setPage(1);
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    getLibelleTypeIntervention(typeOtId) {
      const typeFind = this.parametre(PARAMETRES_KEYS.typeOt).find((type) => {
        return type.id === typeOtId;
      });
      return typeFind ? typeFind.libelle : null;
    },
    getLibelleEtat(etatOt) {
      const etatFind = LIST_ETAT_OT_TECH.find((etat) => {
        return etat.code === etatOt;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
    addActionsImpression() {
      this.actions.splice(0, 0,
        { action: ACTION_MASS_A_EXPEDIER, translation: 'listeOrdreTravailTech.actions.aExpedier' },
      );
      this.actions.splice(5, 0,
        { action: ACTION_MASS_EXPEDIER, translation: 'listeOrdreTravailTech.actions.expedie' },
      );
    },
    getAgenceLibelle(agenceId) {
      const agence = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      return agence ? agence.libelleAgence : '';
    },
    async updateEtatOtMultipe(questions) {
      this.messagesErreurPopUp = [];
      this.errorPopUp = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const otTechniqueIds = [...new Set(this.getAllOTSelected()
          .map(otTechnique => otTechnique.id))];
        let impactEtatDemandes = false;
        let realiserActionIntervention = false;
        let isAnnulatonSuppression = false;
        if (questions && questions
          .find((q) => { return q.key === 'realiserActionIntervention'; })) {
          realiserActionIntervention = this.questionsPopUpPrevention.find((q) => {
            return q.key === 'realiserActionIntervention';
          }).value;
        }
        if (questions && questions
          .find((q) => { return q.key === 'impactEtatDemandes'; })) {
          impactEtatDemandes = this.questionsPopUpPrevention.find((q) => {
            return q.key === 'impactEtatDemandes';
          }).value;
        }
        if (questions && questions
          .find((q) => { return q.key === 'isAnnulatonSuppression'; })) {
          isAnnulatonSuppression = this.questionsPopUpPrevention.find((q) => {
            return q.key === 'isAnnulatonSuppression';
          }).value;
        }
        await changerEtatOtTechnique(
          otTechniqueIds,
          this.etatAchanger,
          realiserActionIntervention,
          impactEtatDemandes,
          isAnnulatonSuppression,
        );
        messageSucces(this.$i18n.t('detailOrdreTravailTech.messages.changer.success'));
        this.isComponentChangerEtatOtTechnique = false;
        this.recherche();
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messagesErreurPopUp, this.ordresTravail);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    openPopUpDelete(ot) {
      this.questionsPopUpPrevention = [];
      if (ot.otPatrimoine && (ot.typeOt.actionInterventionOt === MONTAGE
        || ot.typeOt.actionInterventionOt === DEMONTAGE)) {
        this.questionsPopUpPrevention = [{
          key: 'isAnnulatonSuppression',
          value: true,
          message: ot.typeOt.actionInterventionOt === MONTAGE
            ? 'listeOrdreTravailTech.popUpSuppression.demonter'
            : 'listeOrdreTravailTech.popUpSuppression.monter',
        }];
      }
      this.popUpSuppression = true;
      this.idOtDelete = ot.id;
    },
    async deleteOt(questions) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        let isAnnulatonSuppression = false;
        if (questions && questions
          .find((q) => { return q.key === 'isAnnulatonSuppression'; })) {
          isAnnulatonSuppression = this.questionsPopUpPrevention.find((q) => {
            return q.key === 'isAnnulatonSuppression';
          }).value;
        }
        await deleteOt(this.idOtDelete, isAnnulatonSuppression);
        messageSucces(this.$t('listeOrdreTravailTech.messages.success.otDelete'));
        loadingComponent.close();
        this.popUpSuppression = false;
        this.recherche();
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messagesErreurPopUp, this.ordresTravail);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.$route.params.faceId) {
        this.critereRecherche.faceIds.push(this.$route.params.faceId);
      }
      this.setInformationPage(this.$t('pageLogistique.ot.listeTech'));
      await this.loadParametres([PARAMETRES_KEYS.typeOt]);
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.demandeImpression.key]);
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.afficherProjetDossierLogistiqueTechnique.key]);
      if (this.moduleImpressionActive) {
        this.addActionsImpression();
      }
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};

</script>
